import React, { lazy, Suspense } from "react";
import SEO from "../../components/seo/seo";
import HeroSection from "../../components/Hero/HeroSection";
import NavBar from "../../Nav Bar/NavBar";


const Home = () => {
  // Lazy loading components to optimize performance}
  
  const SellGiftCardSection = lazy(() => import("../../components/sellGiftCard/SellGiftCardSection"));
  const PromotionComponet = lazy(() => import("../../components/promotion/PromotionComponet"));
  const FeatureSection = lazy(() => import("../../components/feature/FeatureSection"));
  const CustomerReviews = lazy(() => import("../../components/customerReviews/CustomerReviews"));

  return (
    <>
      <SEO 
        title="The Best Gift Card Trading Platform | GiftCard8"
        description="Trade your gift cards securely with GiftCard8. Get the best competitive rates for different brands."
        keywords="sell gift cards, trade gift cards, gift card rates, GC8"
        image="https://giftcard8.com/home-og-image.jpg"
        url="https://giftcard8.com/"
      />
      
      <div className="bg">
        <NavBar />
        <HeroSection />
      </div>

      <Suspense fallback={<div>Loading section...</div>}>
        <SellGiftCardSection />
        <PromotionComponet />
        <FeatureSection />
        <CustomerReviews />
      </Suspense>
    </>
  );
};


export default Home;
